<template>
  <div id="app">
    <yetkidialog ref="yetkidialog"></yetkidialog>
    <loadingcomp v-bind:mesaj="' '" v-model="loadingvmodel"></loadingcomp>
    <snackbarcomp v-bind:mesaj="text1" v-model="snackbar"></snackbarcomp>
    <v-dialog v-model="deleteDialog" max-width="400px">
      <v-toolbar color="warning">
        <v-toolbar-title class="white-text">
          <span class="white--text">Bilanço Format Sil</span>
        </v-toolbar-title>
      </v-toolbar>
      <v-card color="white">
        <v-card-text class="blockquote">
          {{ $t('Are-you-sure-want-delete') }}
        </v-card-text>
        <v-divider></v-divider>
        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn @click="deleteDialog = false" outline color="warning">
            {{$t('Cancel')}}
          </v-btn>
          <v-btn outline color="info" @click="deleteFormat()">  {{ $t('Delete') }} </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
    <v-dialog v-model="editDataDialog" max-width="900px">
        <v-toolbar color="info">
        <v-toolbar-title class="white-text">
          <span v-if="this.updateStatus==1" class="white--text">Beyanname Değişkeni Düzenle</span>
          <span v-if="this.updateStatus==0" class="white--text">Beyanname Değişkeni Ekle</span>
        </v-toolbar-title>
      </v-toolbar>
      <v-card>
        <v-card-text>
 <v-layout row>
      <v-flex md5 sm5>
<v-card>
  <v-card-title primary-title>
          <h3 class="">Açıklama</h3>
        </v-card-title>
        <v-card-text>
 <template v-for="(item, index) in seciliItemlar" style="height:100%">
              <v-layout row wrap v-if="item.listid>=0">
            <v-flex md11 sm11 class="d-flex align-center">
            <span>{{ '>' }} {{ item.dec }}</span> 
              </v-flex>
               <v-flex md1 sm1 d-flex align-center v-if="item.sil && item.id!=topLewelId">
                   <v-btn
                @click="setExplanationGeriAl(item.id)"
                icon
                small
                flat
              >
                <v-icon color="info">delete</v-icon>
              </v-btn>
            
          </v-flex>
              </v-layout>
            
          
            <v-layout row wrap v-else>
            <v-flex md11 sm11>
               <v-select :items="items2" label="Seç" item-text="Explanation" v-model="setExplanation" item-value="Id">
               </v-select>
               </v-flex>
          <v-flex md1 sm1 d-flex align-center>
              <v-btn
                @click="setExplanationOnayla()"
                icon
                small
                flat
              >
                <v-icon color="info">check</v-icon>
              </v-btn>
            
          </v-flex>
            </v-layout>
            </template> 
        </v-card-text>
</v-card>
         
      </v-flex>
       <v-flex md7 sm7>
<!--fomul-->
<div>
  <v-card>
     <v-card-title primary-title>
       <h3 class="subheader">Formül</h3>
          
          
     </v-card-title>
     <v-card-text>
      <br v-if="seciliFormulItemlar.lenght==1">
 <template v-for="(item, index) in seciliFormulItemlar">
            <!-- <v-layout row wrap>
              <v-flex md11 sm11 d-flex align-center>
               {{ '>' }}   {{ item.hesap }}  {{ item.islemadi }}  {{ item.islemtipadi }}
              </v-flex>
                 <v-flex md1 sm1 d-flex align-center>
                   <v-btn
                
                @click="setFormulGeriAl(item.hesap)"
                icon
                small
                flat
              >
                <v-icon color="info">delete</v-icon>
              </v-btn>
               
          </v-flex>
            </v-layout> -->
                 <v-layout row wrap >
            <v-flex md6 sm6>
               <!-- <catimuhasebekodu
                    v-model="setHesap"
                    :controlValue="setHesap"
                    :companyID="credentials.MuhasebeSirketNo"
                    :text="$t('Accounting-Code')"
                    :Coper="false"
                  >
                  </catimuhasebekodu> -->
               <muhasebekoducomp  :etiket="$t('Accounting-Code')" maxlength="25" v-model="item.hesap" :readonly="true" :hint="$t('Arama Butonu ile Seçim Yapabilirsiniz')"></muhasebekoducomp>
               </v-flex>
                <v-flex md3 sm3>
               <v-select :items="islemler" label="İşlem" item-text="islemadi" v-model="item.islem" item-value="id">
               </v-select>
               </v-flex>
                 <v-flex md2 sm2>
               <v-select :items="islemtipleri" label="Tip" item-text="islemadi" v-model="item.islemtip" item-value="id">
               </v-select>
               </v-flex>
  <v-flex md1 sm1 d-flex align-center>
      <v-btn
                
               @click="setFormulGeriAl(item.hesap)"
                icon
                small
                flat
              >
                <v-icon color="info">delete</v-icon>
              </v-btn>
            
               </v-flex>
            </v-layout>
           
            </template>
               <v-layout row wrap >
            <v-flex md6 sm6>
               <!-- <catimuhasebekodu
                    v-model="setHesap"
                    :controlValue="setHesap"
                    :companyID="credentials.MuhasebeSirketNo"
                    :text="$t('Accounting-Code')"
                    :Coper="false"
                  >
                  </catimuhasebekodu> -->
               <muhasebekoducomp  :etiket="$t('Accounting-Code')" maxlength="25" v-model="setHesap" :readonly="true" :hint="$t('Arama Butonu ile Seçim Yapabilirsiniz')"></muhasebekoducomp>
               </v-flex>
                <v-flex md3 sm3>
               <v-select :items="islemler" label="İşlem" item-text="islemadi" v-model="setislem" item-value="id">
               </v-select>
               </v-flex>
                 <v-flex md2 sm2>
               <v-select :items="islemtipleri" label="Tip" item-text="islemadi" v-model="setislemtip" item-value="id">
               </v-select>
               </v-flex>
  <v-flex md1 sm1 d-flex align-center>
      <v-btn
                
                @click="setFormulSatirOnayla()"
                icon
                small
                flat
              >
                <v-icon color="info">check</v-icon>
              </v-btn>
            
               </v-flex>
            </v-layout>
     </v-card-text>
  </v-card>

</div>
          
      </v-flex>
      
    </v-layout>
     <v-layout row wrap>
<v-flex class="text-xs-right">
   <v-btn @click="editDataDialog = false" outline color="warning">
            {{$t('Cancel')}}
          </v-btn>
          <v-btn v-if="this.updateStatus==1"  outline color="info" @click="updateFormat()"> {{ $t('Update') }} </v-btn>
          <v-btn v-if="this.updateStatus==0"  outline color="info" @click="addFormat()"> {{ $t('Add') }} </v-btn>
</v-flex>
     </v-layout>
        </v-card-text>
      </v-card>
    
    
   
    
    </v-dialog>

    <v-card color="grey lighten-5" flat>
      <v-layout row wrap>
        <v-flex xs12 sm12>
          <v-toolbar size="120px" dark color="info">
            <v-toolbar-title>Beyanname Format</v-toolbar-title>
            <v-spacer></v-spacer>
            <v-text-field
              flat=""
              solo-inverted=""
              hide-details
              v-model="search"
              :label="$t('Search')"
              append-icon="search"
            >
            </v-text-field>
            <v-spacer></v-spacer>

<v-tooltip bottom>
  <!-- :disabled="!sayfayetki.Save" -->
  <v-btn slot="activator" @click="AddLine()" flat>
    <span class="hidden-sm-and-down">
      <span class="hidden-sm-and-down">Satır Ekle</span>
    </span>
    <v-icon right dark>add_box</v-icon>
  </v-btn>
  <!-- <span v-if="!sayfayetki.Save">{{ $t('Limited-Authorization') }}</span>
  <span v-if="sayfayetki.Save">Banka Pos Ekle</span> -->
</v-tooltip>
            <v-menu offset-y>
              <!-- <v-btn slot="activator" dark icon>
                <v-icon>more_vert</v-icon>
              </v-btn>
              <v-list>
                <v-list-tile @click="getListHtml()">
                  <v-list-tile-title
                    >Html {{ $t("Download") }}</v-list-tile-title
                  >
                </v-list-tile>

                <v-list-tile @click="getListExcel()">
                  <v-list-tile-title
                    >Excel {{ $t("Download") }}</v-list-tile-title
                  >
                </v-list-tile>
              </v-list> -->
            </v-menu>
          </v-toolbar>
        </v-flex>


        <v-container fluid="">
          <v-card color="grey lighten-5" flat>
           
            <v-layout>
              <v-flex xs12 sm12 md12 pt-2>
                <v-card flat>
                  <v-data-table
                    :headers="headers"
                    class="elevation-1"
                    :rows-per-page-items="[50, 100, 250, 500]"
                    :items="items"
                    :search="search"
                  >
                    <template slot="items" slot-scope="props">
                      <tr item>
                        <td class="text-xs-left">
                        {{ props.item.LineNumber  }}
                      </td>
                      <td class="text-xs-left">
                        {{ props.item.Explanation }}
                      </td>
                      <td class="text-xs-left">
                        {{ props.item.Formula }}
                      </td>
                      
                      <td class="justify-start layout px-0">
        
          <v-btn
                
                @click="editDialogOpen(props.item)"
                icon
                small
                flat
              >
                <v-icon color="info">edit</v-icon>
              </v-btn>
              <v-btn
                
                @click="deleteDialogOpen(props.item)"
                icon
                small
                flat
              >
                <v-icon color="info">delete</v-icon>
              </v-btn>
        </td>
                      </tr>
                    
                    </template>
                  </v-data-table>
                </v-card>
              </v-flex>
            </v-layout>
          </v-card>
        </v-container>
      </v-layout>
    </v-card>
  </div>
</template>

<script>
import yetkidialog from "@/components/app/customcomp/yetkidialog.vue";
import snackbarcomp from "@/components/app/customcomp/snackbarcomp";
import loadingcomp from "@/components/app/customcomp/loadingcomp";
import helpers from "@/components/app/customcomp/helpers.js";
import tarihcomp from "../../customcomp/tarihim";
import auth from "../../../../api/auth";
import catimuhasebekodu from "../comp/catimuhasebekodu.vue";
import Tahsilatdialog from "../../pakettur/tahsilatdialog.vue";
import muhasebekoducomp from '@/components/app/customcomp/muhasebekoducomp'
export default {
  data() {
    return {
      LowestSecildi:false,
      topLewelId:0,
      setHesap:'',
      setislem:1,
      setislemtip:1,
      islemler:[
        {
          islemadi:'Borç',
          id:1,
          code:'b'
        },
         {
          islemadi:'Alacak',
          id:2,
           code:'a'
        },
         {
          islemadi:'Borç Bakiye',
          id:3,
           code:'bb'
        },
          {
          islemadi:'Alacak Bakiye',
          id:4,
          code:'ab'
        }
      ],
       islemtipleri:[
        {
          islemadi:'+',
          id:1
        },
         {
          islemadi:'-',
          id:2
        },
       
      ],
      setFormul:'',
      setExplanation:null,
      updateStatus:0,
      aktifPasifler:[
    {
          text: "Aktif",
          value:'A'
     },
     {
          text: "Pasif",
          value:'P'
     },
   
    ],
    deleteDialog:false,
      editDataDialog:false,
      formatData: {
        Ap: '',
        CompanyID: 0,
        DeptCredit: false,
        Explanation: '',
        ID: 0,
        Kebir:'0',
        LineNumber:'0'
      },
    dovizTipleri:[
    {
          text: "TL",
          value:0
     },
     {
          text: "Döviz",
          value:1
     },
     {
          text: "Döviz + TL",
          value:3
     },
    ],
      dialogfiltre:false,
      search: null,
      text1: null,
      snackbar: false,
      yetkidialog: false,
      loadingvmodel: false,
      sayfayetki: {
        Screen: false,
        Update: false,
        Save: false,
        Delete: false,
        Status: false,
        Message: null,
        islem: 0,
      },
      valid: true,
      
     
     
      credentials: JSON.parse(window.localStorage.getItem("credentials")),
      items: [],
      items2:[],
      seciliItemlar:[],
      seciliFormulItemlar:[],
      headers: [
        {
          text: 'Satır',
          value: 'LineNumber'
        },
        {
          text: 'Açıklama',
          value: 'Explanation',
          sortable: false
        },
        {
          text: 'Formul',
          value: 'Formula',
          sortable: false
        },
       
        {
          text: 'İşlem',
          sortable: false
        },
      ],
    };
  },
  methods: {
  setFormulGeriAl(code){
const index = this.seciliFormulItemlar.findIndex(x => x.hesap === code);

if (index !== -1) {
  this.seciliFormulItemlar.splice(index, 1);   
}
  },
    setFormulSatirOnayla(){
      if (this.setHesap==''){
        return;
      }
      var islemad="";
      var islemtipadi="";
      var islemcode="";
       for (const element of this.islemler) {
        if (element.id==this.setislem){
     islemad=element.islemadi;
     islemcode=element.code;
    }
       
   
}
 for (const element of this.islemtipleri) {
    if (element.id==this.setislemtip){
     islemtipadi=element.islemadi;
    }
}

       this.seciliFormulItemlar.push({hesap:this.setHesap,islem:this.setislem,islemtip:this.setislemtip,islemadi:islemad,islemtipadi:islemtipadi,islemcode:islemcode});
       this.setHesap ='';
    },
    setExplanationGeriAl(id){
       const index = this.seciliItemlar.findIndex(x => x.id === id); 
       if (index !== -1) {
         if (index > 0) {
    let oncekiId = this.seciliItemlar[index - 1].id;
    this.GetAccDecCaptionsLineList(oncekiId);
    if (this.seciliItemlar.length>1){
      this.seciliItemlar[index - 1].sil=true;
    }
  }
  this.seciliItemlar.splice(index, 1); 
 
  const indexyeni = this.seciliItemlar.findIndex(x => x.listid === -1);
    if (indexyeni==-1){
 var accitem2={id:0,dec:'',listid:-1};
     this.seciliItemlar.push(accitem2);
    }
    this.LowestSecildi=false;
}
    },
    setExplanationOnayla(){
      if (this.setExplanation==null){
        return;
      }
      let name='';
      var lowest=false;
        for (const element of this.items2) {
    if (element.Id==this.setExplanation){
    if (element.IsLowestLevel){
      lowest=true;
    }
      name=element.Explanation;
    }
}

     for (const element of this.seciliItemlar) {
      element.sil=false;
    if (element.listid==-1){
      element.id=this.setExplanation;
      element.listid=this.seciliItemlar.length;
      element.dec=name;
      element.sil=true;
    }
}
if (!lowest){
  this.LowestSecildi=false;
   var accitem2={id:0,dec:'',listid:-1};
   this.seciliItemlar.push(accitem2);
  this.GetAccDecCaptionsLineList(this.setExplanation);
}else{
  this.LowestSecildi=true;
}
              
this.setExplanation=null;
    },
     GetAccDecCaptionsTopLevel(){
  let params = {
      
        CompanyID: this.credentials.MuhasebeSirketNo,
        UserID:this.credentials.UserID,
        TopLevelId:0
      };
     
          this.$http
            .post(
              auth.API_URL + "api/AccountingReports/AccDecCaptionsLineList",
              params,
              {
                headers: {
                  Authorization: "Bearer " + auth.getAuthHeader(),
                },
              }
            )
            .then(
              (response) => {

                this.items2=response.body.lines;
            
                this.topLewelId=this.items2[0].Id;
                var accitem2={id:this.items2[0].Id,dec:this.items2[0].Explanation,listid:0};
                this.seciliItemlar.push(accitem2);
                this.GetAccDecCaptionsLineList(this.items2[0].Id);
                var accitem3={id:0,dec:'',listid:-1};
                this.seciliItemlar.push(accitem3);
               

               
              },
              (response) => {
                if (response.status === 0) {
                  this.text1 = "Service Unavailable";
                  this.snackbar = true;
                } else {
                  this.text1 = "Service Unavailable";
                  this.snackbar = true;
                }
              }
            );
        
     
    },
    async GetAccDecCaptionsLineList(topid) {
  const params = {
    CompanyID: this.credentials.MuhasebeSirketNo,
    UserID: this.credentials.UserID,
    TopLevelId: topid,
  };

  try {
    const response = await this.$http.post(
      auth.API_URL + "api/AccountingReports/AccDecCaptionsLineList",
      params,
      {
        headers: {
          Authorization: "Bearer " + auth.getAuthHeader(),
        },
      }
    );

    this.items2 = response.body.lines || [];

    
    if (topid === 0 && this.updateStatus === 0 && this.items2.length > 0) {
      let accitem2 = {
        id: this.items2[0].Id,
        dec: this.items2[0].Explanation,
        listid: 0,
      };
      this.seciliItemlar.push(accitem2);

      accitem2 = { id: 0, dec: "", listid: -1 };
      this.seciliItemlar.push(accitem2);

      
      await this.GetAccDecCaptionsLineList(this.items2[0].Id);
    }
  } catch (response) {
    if (response.status === 0) {
      this.text1 = "Service Unavailable";
      this.snackbar = true;
    } else {
      this.text1 = "Service Unavailable";
      this.snackbar = true;
    }
  }
},

   async GetAccDecCaptionsLineListeski(topid){
    
  let params = {
      
        CompanyID: this.credentials.MuhasebeSirketNo,
        UserID:this.credentials.UserID,
        TopLevelId:topid
      };
     
          this.$http
            .post(
              auth.API_URL + "api/AccountingReports/AccDecCaptionsLineList",
              params,
              {
                headers: {
                  Authorization: "Bearer " + auth.getAuthHeader(),
                },
              }
            )
            .then(
              (response) => {

               this.items2=response.body.lines;
              
               if (topid==0 && this.updateStatus==0){
                var accitem2={id:this.items2[0].Id,dec:this.items2[0].Explanation,listid:0};
                this.seciliItemlar.push(accitem2);
                var accitem2={id:0,dec:'',listid:-1};
                this.seciliItemlar.push(accitem2);
                GetAccDecCaptionsLineList(this.items2[0].Id);
               }

               
              },
              (response) => {
                if (response.status === 0) {
                  this.text1 = "Service Unavailable";
                  this.snackbar = true;
                } else {
                  this.text1 = "Service Unavailable";
                  this.snackbar = true;
                }
              }
            );
        
     
    },
   
    moneyformat: function (m) {
      return helpers.moneyformat(m);
    },
   
    getparabirimi() {
      return helpers.getparabirimi();
    },
    AddLine(){
      this.seciliItemlar=[];
      this.seciliFormulItemlar=[];
      this.LowestSecildi=false;
       this.GetAccDecCaptionsTopLevel();
       this.updateStatus=0;
      //  this.formatData.Ap="A";
      //  this.formatData.DeptCredit=false;
      //  this.formatData.Explanation='';
      //  this.formatData.LineNumber=null;
      //  this.formatData.Kebir=null;
       this.editDataDialog=true;
    },
    deleteDialogOpen(val) {
      this.formatData=val;
      this.deleteDialog=true;
    },
parseFormula(text) {
    if (!text) return [];

   
    const parts = String(text).trim().split(/\s+/);

    const result = [];

   
    for (let i = 0; i < parts.length; i += 3) {
        result.push({
            hesap: parts[i] || "",
            islemkod: parts[i + 1] || "",
            islemtipadi: parts[i + 2] || ""
        });
    }

    return result;
},



   async editDialogOpen(val) {
      this.updateStatus=1;
      
      //this.seciliFormulItemlar.push({hesap:this.setHesap,islem:this.setislem,islemtip:this.setislemtip,islemadi:islemad,islemtipadi:islemtipadi,islemcode:islemcode});
      this.seciliFormulItemlar=[];
      this.seciliItemlar=[];
    
    const result = this.parseFormula(val.Formula);
    console.log(result);
    for (let s of result){
    var islemtipadi='+';
    var islemtip=1;
    var islemcode='';
    var islem='';
    var islemadi='';
     if (s.islemtipadi=="-"){
      islemtip=2;
      islemtipadi="-";
    }
      if (s.islemkod.includes("bb")) {
    islemcode='bb';
    islemadi='Borç Bakiye';
    islem=3;
}else if(s.islemkod.includes("ab")){
   islemcode='ab';
    islemadi='Alacak Bakiye';
    islem=4;
}
else if(s.islemkod.includes("b")){
   islemcode='b';
    islemadi='Borç';
    islem=1;
}
else if(s.islemkod.includes("a")){
   islemcode='a';
    islemadi='Alacak';
    islem=2;
}
this.seciliFormulItemlar.push({hesap:s.hesap,islem:islem,islemtip:islemtip,islemadi:islemadi,islemtipadi:islemtipadi,islemcode:islemcode});
    }
   

 



  let exp = val.Explanation.split(/[>]/);
  var flagid=1;
  

let lowestid=0;

var index=0;
  for (let item of exp) {
    
    if (index===0){
       this.seciliItemlar.push({id:1,dec:item,listid:this.seciliItemlar.length});
       index+=1;
    }else{
      
     await this.GetAccDecCaptionsLineList(flagid);
     
        for (var subitem of this.items2) {
        
          
      var g=subitem.Explanation.trim();
      var gg=item.trim();
        if (g==gg){
           this.seciliItemlar.push({id:subitem.Id,dec:item,listid:this.seciliItemlar.length,sil:false});
           flagid=subitem.Id;
           if (subitem.IsLowestLevel){
            lowestid=subitem.Id;
           }
           break;
        }
    }
    }
   
 

  
    
  }
   if (this.seciliItemlar.length>1){
    this.seciliItemlar[this.seciliItemlar.length-1].sil=true;
  }
if (lowestid==0){
 await  this.GetAccDecCaptionsLineList(flagid);
 
  this.seciliItemlar.push({id:0,dec:'',listid:-1});
}

      this.LowestSecildi=true;
      this.formatData=val;
      this.editDataDialog=true;
    },
    addFormat()
    {
      if (this.seciliFormulItemlar.length==0){
            this.text1 = 'Lütfen Formül Bilgilerini Giriniz.';
            this.snackbar = true;
            return;
      }
      if (this.LowestSecildi==false){
            this.text1 = 'Lütfen Açıklama Bilgilerini Giriniz. En Alt Seviyeye Kadar Seçim Yapılmalı.';
            this.snackbar = true;
            return;
      }
      this.loadingvmodel = true;

for (const formulitem of this.seciliFormulItemlar) {
      var islemad="";
      var islemtipadi="";
      var islemcode="";
       for (const element of this.islemler) {
        if (element.id==formulitem.islem){
     islemad=element.islemadi;
     islemcode=element.code;
    }
}
  for (const element of this.islemtipleri) {
    if (element.id==formulitem.islemtip){
     islemtipadi=element.islemadi;
    }
}
formulitem.islemadi=islemad;
formulitem.islemtipadi=islemtipadi;
formulitem.islemcode=islemcode;
    
   
}



      var Explanationstr='';
       for (const element of this.seciliItemlar) {
        if (element.listid>=0){
          Explanationstr+=element.dec + ' >' + ' ';
        }
  
}
Explanationstr = Explanationstr.slice(0, -2);
 var formulastr='';
       for (const element of this.seciliFormulItemlar) {
      formulastr+=element.hesap + ' ' + element.islemcode + ' ' + element.islemtipadi + ' ';
}
formulastr = formulastr.slice(0, -2);
      var linedata={
        ID:0,
        CompanyID:this.credentials.MuhasebeSirketNo,
        LineNumber:this.items.length + 1,
Explanation:Explanationstr,
Formula:formulastr
      };
    
      let params = {
        Update: 0,
        UserID:this.credentials.UserID,
        Line:linedata
      };
      this.$http
        .post(
          auth.API_URL + "api/AccountingReports/AccountingDeclarationLineSave",
          params,
          {
            headers: {
              Authorization: "Bearer " + auth.getAuthHeader(),
            },
          }
        )
        .then(
          (response) => {
           
            this.text1 = response.body.ResponseMessage;
            this.snackbar = true;
            this.getList();
            this.seciliFormulItemlar=[];
            this.items=[];
            this.seciliItemlar=[];
            this.setExplanation=null;
            this.setFormul=null;
            this.setHesap='';
            this.setislem=1;
            this.setislemtip=1;
            this.editDataDialog = false;
            this.loadingvmodel = false;
          },
          (response) => {
            if (response.status === 0) {
              this.text1 = "Service Unavailable-StatementLineSave";
              this.snackbar = true;
              this.editDataDialog = false;
              this.loadingvmodel = false;
            } else {
              this.text1 = "Service Unavailable-StatementLineSave";
              this.snackbar = true;
              this.editDataDialog = false;
              this.loadingvmodel = false;
            }
          }
        );
    },
    updateFormat()
    {
        if (this.seciliFormulItemlar.length==0){
            this.text1 = 'Lütfen Formül Bilgilerini Giriniz.';
            this.snackbar = true;
            return;
      }
      if (this.LowestSecildi==false){
            this.text1 = 'Lütfen Açıklama Bilgilerini Giriniz. En Alt Seviyeye Kadar Seçim Yapılmalı.';
            this.snackbar = true;
            return;
      }
 for (const formulitem of this.seciliFormulItemlar) {
      var islemad="";
      var islemtipadi="";
      var islemcode="";
       for (const element of this.islemler) {
        if (element.id==formulitem.islem){
     islemad=element.islemadi;
     islemcode=element.code;
    }
}
  for (const element of this.islemtipleri) {
    if (element.id==formulitem.islemtip){
     islemtipadi=element.islemadi;
    }
}
formulitem.islemadi=islemad;
formulitem.islemtipadi=islemtipadi;
formulitem.islemcode=islemcode;
    
   
}


      this.loadingvmodel = true;
     var Explanationstr = '';

for (const element of this.seciliItemlar) {
  
  if (element.listid >= 0) {

    
    const temizDec = element.dec.trim();

    
    Explanationstr += temizDec + ' > ';
  }
}
Explanationstr = Explanationstr.slice(0, -3);
 var formulastr='';
       for (const element of this.seciliFormulItemlar) {
      formulastr+=element.hesap + ' ' + element.islemcode + ' ' + element.islemtipadi + ' ';
}
formulastr = formulastr.slice(0, -3);
      var linedata={
        ID:this.formatData.ID,
        CompanyID:this.credentials.MuhasebeSirketNo,
        LineNumber:this.formatData.LineNumber,
Explanation:Explanationstr,
Formula:formulastr
      };
    
      let params = {
        Update: 1,
        UserID:this.credentials.UserID,
        Line:linedata
      };
      this.$http
        .post(
          auth.API_URL + "api/AccountingReports/AccountingDeclarationLineSave",
          params,
          {
            headers: {
              Authorization: "Bearer " + auth.getAuthHeader(),
            },
          }
        )
        .then(
          (response) => {
           
            this.text1 = response.body.ResponseMessage;
            this.snackbar = true;
            this.getList();
            this.editDataDialog = false;
            this.loadingvmodel = false;
          },
          (response) => {
            if (response.status === 0) {
              this.text1 = "Service Unavailable-StatementLineSave";
              this.snackbar = true;
              this.editDataDialog = false;
              this.loadingvmodel = false;
            } else {
              this.text1 = "Service Unavailable-StatementLineSave";
              this.snackbar = true;
              this.editDataDialog = false;
              this.loadingvmodel = false;
            }
          }
        );
    },
    deleteDialogOpen(val) {
      this.formatData=val;
     this.deleteDialog=true;
    },
    deleteFormat()
    {
      this.loadingvmodel = true;
      let params = {
        
        UserID:this.credentials.UserID,
        AccountingDeclarationLineId:this.formatData.ID
      };
      this.$http
        .post(
          auth.API_URL + "api/AccountingReports/AccountingDeclarationLineDelete",
          params,
          {
            headers: {
              Authorization: "Bearer " + auth.getAuthHeader(),
            },
          }
        )
        .then(
          (response) => {
           
            this.text1 = response.body.ResponseMessage;
            this.snackbar = true;
            this.getList();
            this.deleteDialog = false;
            this.loadingvmodel = false;
          },
          (response) => {
            if (response.status === 0) {
              this.text1 = "Service Unavailable-StatementLineDelete";
              this.snackbar = true;
              this.deleteDialog = false;
              this.loadingvmodel = false;
            } else {
              this.text1 = "Service Unavailable-StatementLineDelete";
              this.snackbar = true;
              this.deleteDialog = false;
              this.loadingvmodel = false;
            }
          }
        );
    },
   
   
    getList() {
      let params = {
      
        CompanyID: this.credentials.MuhasebeSirketNo,
        UserID:this.credentials.UserID
      };
     
          this.$http
            .post(
              auth.API_URL + "api/AccountingReports/AccountingDeclarationLineList",
              params,
              {
                headers: {
                  Authorization: "Bearer " + auth.getAuthHeader(),
                },
              }
            )
            .then(
              (response) => {

               this.items=response.body.lines;
              
             
               
                
              },
              (response) => {
                if (response.status === 0) {
                  this.text1 = "Service Unavailable";
                  this.snackbar = true;
                } else {
                  this.text1 = "Service Unavailable";
                  this.snackbar = true;
                }
              }
            );
        
     
    },
  
  },
  filters: {
    dateformat: function (t) {
      return helpers.dateformat(t);
    },
    moneyformat: function (m) {
      return helpers.moneyformat(m);
    },

    bakiyekontrol: function (m) {
      return helpers.bakiyekontrol(m);
    },
  },
  components: {
    yetkidialog,
    snackbarcomp,
    loadingcomp,
    tarihcomp,
    catimuhasebekodu,
    muhasebekoducomp
  },
  beforeRouteEnter(to, from, next) {
    next((vm) => {
      vm.prevRoute = from.path;
    });
  },
  mounted() {
    this.sayfayetki = helpers.pageScreenAuth(this.$route.name);
    this.getList();
    // if (this.sayfayetki.Status == true) {
    //   //YETKİ OK
    // } else {
    //   this.$refs.yetkidialog
    //     .open(this.sayfayetki.Message, this.sayfayetki.islem)
    //     .then((sonuc) => {
    //       if (sonuc == true) {
    //         if (this.prevRoute != null) {
    //           var url = "#" + this.prevRoute;

    //           window.open(url, "_self");
    //         } else {
    //           var mainUrl = "#/";
    //           window.open(mainUrl, "_self");
    //         }
    //       }
    //     });
    // }
  },
};
</script>

<style>
</style>

